import { render } from "./UserCustomerDialog.vue?vue&type=template&id=739615d3"
import script from "./UserCustomerDialog.vue?vue&type=script&lang=js"
export * from "./UserCustomerDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__